<template>
  <van-nav-bar @click-left="onClickLeft" :left-arrow="!$slots['left']?true:false" :z-index="1000" :border="false" placeholder :safe-area-inset-top="true" fixed>
    <template slot="title">
      <span class="box-title">{{title}}</span>
    </template>
    <!-- 处理 scopedSlots -->
    <template v-for="slotName of scopedSlotsKeys" :slot="slotName">
      <slot :name="slotName"></slot>
    </template>

    <!-- 处理 slots -->
    <template v-for="slotName of slotsKeys" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
  </van-nav-bar>
</template>

<script>
export default {
  name: 'LayoutHeader',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  computed: {
    slotsKeys () {
      return Object.keys(this.$slots).filter(key => !this.usedSlots.includes(key))
    },
    scopedSlotsKeys () {
      return Object.keys(this.$scopedSlots).filter(key => !this.usedSlots.includes(key))
    }
  },
  data () {
    return {
      usedSlots: ['title']
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  /*.box-title{*/
  /*  font-weight: bold;*/
  /*  font-size: 32px;*/
  /*}*/
</style>
